export const LOCALE_PREFIX = 'scenes.Gnosus.components.ModuleMenu.components.Content.components.MenuItem'
